import { render, staticRenderFns } from "./SponsorsReport.vue?vue&type=template&id=172897a4&v-else=true&"
import script from "./SponsorsReport.vue?vue&type=script&lang=js&"
export * from "./SponsorsReport.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports